import React, { useEffect, useState } from "react";

function SlideshowScreen({ backendUrl, memories, viewMode, onBack }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // AUTO MODE
  useEffect(() => {
    if (viewMode !== "carousel") return;
    const interval = setInterval(() => {
      setCurrentIndex((i) => (i === memories.length - 1 ? 0 : i + 1));
    }, 4000);
    return () => clearInterval(interval);
  }, [viewMode, memories.length]);

  if (!memories || memories.length === 0) {
    return (
      <div style={styles.loading}>
        <p>Loading memories...</p>
      </div>
    );
  }

  const memory = memories[currentIndex];

  const nextPhoto = () =>
  setCurrentIndex((prev) => (prev === memories.length - 1 ? 0 : prev + 1));

  const prevPhoto = () =>
    setCurrentIndex((prev) => (prev === 0 ? memories.length - 1 : prev - 1));

  return (
    <div style={styles.page}>

      {/* 🔙 Pulsante Back in alto a sinistra */}
      <button style={styles.backTopLeft} onClick={onBack}>
        <span style={{ marginRight: 10, fontSize: 34 }}>‹</span> Volver a los Álbumes
      </button>
      
      {/* Bottoni laterali — solo modalità manual, fissi ai lati dello schermo */}
      {viewMode !== "carousel" && (
        <>
          <button
            style={styles.leftEdgeButton}
            onClick={prevPhoto}
            aria-label="Anterior"
          >
            ‹
          </button>

          <button
            style={styles.rightEdgeButton}
            onClick={nextPhoto}
            aria-label="Siguiente"
          >
            ›
          </button>
        </>
      )}

      {/* Foto + pulsanti laterali */}
      <div style={styles.photoWrapper}>

        {/* Foto */}
        <img
          src={`${backendUrl}${memory.url}`}
          alt={memory.caption}
          style={styles.image}
        />

      </div>

      {/* Didascalia */}
      <div style={styles.bottomInfo}>
        <h2 style={styles.caption}>{memory.caption}</h2>
        {memory.year && <p style={styles.year}>📅 {memory.year}</p>}
      </div>

    </div>
  );



}

// ----------------------------- STYLES -----------------------------
const styles = {
  page: {
    backgroundColor: "#000",
    height: "100vh",
    width: "100vw",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white"
  },
  photoWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "70vh",
    position: "relative"
  },
  backTopLeft: {
    position: "absolute",
    top: "22px",
    left: "22px",
    padding: "18px 28px",
    backgroundColor: "#225bff",
    color: "white",
    fontSize: "28px",
    border: "none",
    borderRadius: "22px",
    cursor: "pointer",
    zIndex: 10,
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
  },
  sideButton: {
    width: "80px",
    height: "80px",
    fontSize: "40px",
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.2)",
    color: "white",
    border: "none",
    cursor: "pointer",
    margin: "0 20px",
    backdropFilter: "blur(4px)"
  },

  bottomInfo: {
    marginTop: "20px",
    textAlign: "center"
  },

  caption: {
    fontSize: "24px",
    margin: 0
  },

  year: {
    fontSize: "16px",
    marginTop: "5px",
    color: "#ccc"
  },

  image: {
    maxWidth: "70%",
    maxHeight: "100%",
    objectFit: "contain",
    borderRadius: "20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.6)"
  },

  controls: {
    display: "flex",
    gap: "40px",
    marginBottom: "10px",
  },

  navButton: {
    padding: "14px 26px",
    backgroundColor: "#444",
    borderRadius: "20px",
    fontSize: "26px",
    border: "none",
    color: "white",
    cursor: "pointer",
  },

  exitButton: {
    padding: "12px 26px",
    backgroundColor: "#225bff",
    borderRadius: "24px",
    fontSize: "20px",
    border: "none",
    color: "white",
    marginBottom: "10px",
    cursor: "pointer",
  },

  loading: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000",
    color: "#fff",
  },
  
  leftEdgeButton: {
    position: "absolute",
    left: "18px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "150px",
    height: "150px",
    fontSize: "92px",
    fontWeight: 900,
    lineHeight: "92px",
    borderRadius: "75px",
    backgroundColor: "rgba(255,255,255,0.85)",   // molto più visibile
    color: "#000",                                // freccia nera su cerchio bianco
    border: "6px solid rgba(255,255,255,0.95)",   // bordo extra contrasto
    cursor: "pointer",
    zIndex: 9,
    boxShadow: "0 10px 26px rgba(0,0,0,0.60)",
  },

  rightEdgeButton: {
    position: "absolute",
    right: "18px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "150px",
    height: "150px",
    fontSize: "92px",
    fontWeight: 900,
    lineHeight: "92px",
    borderRadius: "75px",
    backgroundColor: "rgba(255,255,255,0.85)",
    color: "#000",
    border: "6px solid rgba(255,255,255,0.95)",
    cursor: "pointer",
    zIndex: 9,
    boxShadow: "0 10px 26px rgba(0,0,0,0.60)",
  }

};

export default SlideshowScreen;
